import React from 'react'
import { customerData } from '../../../utilities/CustomerData'

export function DashboardPendingBank() {
  function MultilineText({ text, textColor }) {
    const lines = text.split('\\n')

    const renderTextWithItalics = (text) => {
      const parts = text.split(/(<i>|<\/i>|<b>|<\/b>)/)
      let isInItalic = false
      let isInBold = false

      return parts.map((part, index) => {
        if (part === "<i>") {
          isInItalic = true
          return null
        } else if (part === "</i>") {
          isInItalic = false
          return null
        } else if (part === '<b>') {
          isInBold = true
          return null
        } else if (part === '</b>') {
          isInBold = false
          return null
        } else {
          if (isInItalic && isInBold) {
            return (
              <b key={index}>
                <i>{part}</i>
              </b>
            )
          } else if (isInItalic)
            return <i key={index}>{part}</i>
          else if (isInBold)
            return <b key={index}>{part}</b>
          else
            return part
        }
      })
    }

    return (
      <div className={`text-left text-${textColor} mt-4`}>
        {lines.map((line, index) => (
          <React.Fragment key={index}>
            {renderTextWithItalics(line)}
            {index !== lines.length - 1 && <><br /><div style={{ height: '8px' }} /></>}
          </React.Fragment>
        ))}
      </div>
    )
  }

  return (
    <div className='lg:w-full w-11/12 flex flex-col gap-4'>
      <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col bg-[#5186C0] font-robo text-white'>
        <div className='w-full flex flex-col items-center gap-4'>
          <p className='font-bold text-3xl text-center'>Pending Bank Validation</p>
          <p className='font-bold text-2xl text-center'>Micro Deposit Estimate Date:</p>
          <p className='font-bold text-2xl text-center'>{new Date(customerData.customerValidiFiBankVerification.estimatedDepositDate).toDateString()}</p>
          <div className='w-10/12 flex flex-col items-center gap-4 mt-4'>
            <button 
              onClick={() => window.innerWidth <= 768 ? window.location.href = customerData.customerValidiFiBankVerification.accessUrl : window.open(customerData.customerValidiFiBankVerification.accessUrl, '_blank')}
              className='w-full p-4 bg-[#FF8C00] hover:bg-[#E67E00] transition duration-200 rounded-lg text-3xl font-bold shadow-md'>
                <div className='flex flex-col items-center gap-2'>
                  <p>Verify Banking Info</p>
                  <p className='text-lg'>Click Here</p>
                </div>
            </button>
          </div>
        </div>
      </div>
      <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col bg-[#5186C0] font-robo text-white'>
        <MultilineText text={customerData.customerStageHistory.find(stage => stage.currentStage === true).customerStageDesc} textColor={'white'} />
      </div>
    </div>
  )
}